import {
	DocumentsResponse,
	ProjectsResponse,
	ReceiptsResponse,
	TasksResponse,
} from "@dune/types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import { dashboardQueryKeys } from "../query-keys/dashboard.query-keys";

export const useGetBrokerReceipts = () => {
	return useQuery({
		queryKey: dashboardQueryKeys.brokerReceipts(),
		queryFn: async (): Promise<ReceiptsResponse> => {
			const response = await privateAxios.get("/dashboard/receipts");
			return response.data;
		},
	});
};

export const useGetBrokerTasks = () => {
	return useQuery({
		queryKey: dashboardQueryKeys.brokerTasks(),
		queryFn: async (): Promise<TasksResponse> => {
			const response = await privateAxios.get("/dashboard/tasks");
			return response.data;
		},
	});
};

export const useGetBrokerProjects = () => {
	return useQuery({
		queryKey: dashboardQueryKeys.brokerProjects(),
		queryFn: async (): Promise<ProjectsResponse> => {
			const response = await privateAxios.get("/dashboard/projects");
			return response.data;
		},
	});
};

export const useGetDuneDocuments = () => {
	return useQuery({
		queryKey: ["duneDocuments"],
		queryFn: async (): Promise<DocumentsResponse> => {
			const response = await privateAxios.get("/dashboard/dune/documents");
			return response.data;
		},
	});
};

export const useGetDuneTasks = () => {
	return useQuery({
		queryKey: ["duneTasks"],
		queryFn: async (): Promise<TasksResponse> => {
			const response = await privateAxios.get("/dashboard/dune/tasks");
			return response.data;
		},
	});
};

export const useGetSyndicTasks = () => {
	return useQuery({
		queryKey: dashboardQueryKeys.syndicTasks(),
		queryFn: async (): Promise<TasksResponse> => {
			const response = await privateAxios.get("/dashboard/syndic/tasks");
			return response.data;
		},
	});
};

export const useGetSyndicProjects = () => {
	return useQuery({
		queryKey: dashboardQueryKeys.syndicProjects(),
		queryFn: async (): Promise<ProjectsResponse> => {
			const response = await privateAxios.get("/dashboard/syndic/projects");
			return response.data;
		},
	});
};

export const useGetAssureurTasks = () => {
	return useQuery({
		queryKey: dashboardQueryKeys.assureurTasks(),
		queryFn: async (): Promise<TasksResponse> => {
			const response = await privateAxios.get("/dashboard/assureur/tasks");
			return response.data;
		},
	});
};

export const useGetAssureurProjects = () => {
	return useQuery({
		queryKey: dashboardQueryKeys.assureurProjects(),
		queryFn: async (): Promise<ProjectsResponse> => {
			const response = await privateAxios.get("/dashboard/assureur/projects");
			return response.data;
		},
	});
};

export const useGetAssureurReceipts = () => {
	return useQuery({
		queryKey: dashboardQueryKeys.assureurReceipts(),
		queryFn: async (): Promise<ReceiptsResponse> => {
			const response = await privateAxios.get("/dashboard/assureur/receipts");
			return response.data;
		},
	});
};
